import React from 'react'

const initialState = {
	hasErrors: false,
	isDirty: false,
	isSubmitting: false,
}

export function useFormState() {
	const [state, setState] = React.useState(initialState)

	const handlers = React.useMemo(
		() => ({
			onHasErrorsChanged: (hasErrors: boolean) => setState((prevState) => ({ ...prevState, hasErrors })),

			onIsDirtyChanged: (isDirty: boolean) => setState((prevState) => ({ ...prevState, isDirty })),

			onIsSubmittingChanged: (isSubmitting: boolean) => setState((prevState) => ({ ...prevState, isSubmitting })),
		}),
		[],
	)

	return [state, handlers] as const
}
